export default class Typekey {
    code: string;

    name: string;

    description: string;

    constructor(_code: string,
      _name: string,
      _description: string) {
      this.code = _code;
      this.name = _name;
      this.description = _description;
    }
}
